const getMessageFromException = function(message) {
    return message.responseJSON.error.replace(/([^\s ]+)/, '').slice(1, -1);
};

export default getMessageFromException;
